import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'clickSyncProcessLogManagementExperience.listExport'

const ClickSyncProcessLogManagementClickSyncProcessLogListExportSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default ClickSyncProcessLogManagementClickSyncProcessLogListExportSlice
